/**
 * generates and returns object of filters if filters exist in url
 */
import * as queryString from "query-string";
import * as H from "history";

import { ILocationState } from "src/pages/Router/routes";

const queryStringFilterData = (location: H.Location<ILocationState>): {[p: string]: string} | null => {
  const query = queryString.parse(location.search);
  const queryFilters = query.filters as string;

  if (queryFilters) {
    const filters = queryFilters.split(",");
    const filtersArray = filters.map(filterElement => filterElement.split(":"));

    return filtersArray.reduce((p: { [filterName: string]: string }, c) => {
      p[ c[ 0 ] ] = c[ 1 ];

      return p;
    }, {});
  }

  return null;
};

export default queryStringFilterData;
